import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import ArticleTitleUnderlineVariant from './ArticleTitleUnderlineVariant.js';
import styles from './OverlayHomeStretchBanner.module.css';

const OverlayHomeStretchBanner = () => {
  const {
    bannerTitle,
    bannerTitleVariant,
    bannerSubtitle,
    bannerLeftImageSrc,
    bannerRightImageSrc,
    bannerBackgroundColor: backgroundColor,
  } = useSearchParamOrDefaultProps();

  const hasBackgroundImageSrc = bannerLeftImageSrc && bannerRightImageSrc;

  const backgroundImgStyles = hasBackgroundImageSrc
    ? {
        backgroundImage: `url(${bannerLeftImageSrc}), url(${bannerRightImageSrc})`,
        backgroundColor,
      }
    : {
        backgroundColor,
      };

  return (
    <div className={styles.bannerWrapper} style={backgroundImgStyles}>
      <div className={styles.bannerTitle}>
        <ArticleTitleUnderlineVariant
          title={bannerTitle}
          variant={bannerTitleVariant}
        />
      </div>
      <div className={styles.bannerSubtitle}>{bannerSubtitle}</div>
    </div>
  );
};

OverlayHomeStretchBanner.displayName = 'OverlayHomeStretchBanner';

export default OverlayHomeStretchBanner;
